export default __webpack_public_path__ + "static/media/recorte_1.28903d81.JPG";